import { ENVS } from '@/constants';
import { openLink } from '@/utils/common';
import { AlertTriangle } from '@ethsign/icons';
import { GradientButton } from './GradientButton';

export function IneligibleStatus() {
  return (
    <div className="bg-card rounded-[16px] p-6 border border-border">
      <div className="flex flex-col items-center text-center space-y-4">
        {/* Warning Icon */}
        <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center">
          <AlertTriangle className="w-8 h-8 text-orange-500" />
        </div>

        {/* Title */}
        <h2 className="text-xl font-semibold text-foreground">Not Eligible for $TAC Airdrop</h2>

        {/* Description */}
        <div className="space-y-2 text-muted-foreground">
          <p>Unfortunately, your wallet address is not eligible for $TAC token rewards in this distribution.</p>
          {/* {address && <p className="text-sm font-mono bg-muted px-3 py-2 rounded-md break-all">{address}</p>} */}
        </div>

        {/* Information */}
        <div className="bg-muted/50 rounded-lg p-4 space-y-2">
          <h3 className="font-medium text-foreground">Possible reasons:</h3>
          <ul className="text-sm text-muted-foreground space-y-1 text-left">
            <li>• Your address was not included in the eligible participants list</li>
            <li>• You may have already claimed your rewards</li>
            <li>• The distribution period may have ended</li>
            <li>• Your address doesn't meet the minimum requirements</li>
          </ul>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 w-full max-w-md">
          <GradientButton
            className="flex-1"
            onClick={() => {
              openLink(ENVS.CommunityUrl);
            }}
          >
            Contact Support
          </GradientButton>
        </div>

        {/* Additional Info */}
        <p className="text-xs text-muted-foreground mt-4">
          If you believe this is an error, please contact our support team with your wallet address.
        </p>
      </div>
    </div>
  );
}
